export type Theme = 'light' | 'dark' | 'system';
export const THEMES: readonly Theme[] = ['light', 'dark', 'system'];

export interface UserSettings {
	theme: Theme;
	presentationMode: boolean;
}

// Mirrors Core.API's UserSettingsDefaults (src/Models/UserSettingsDTO.cs) — the server is the
// source of truth, and these must agree with it. This is the ONLY copy of the defaults on the
// client: UserSettingsService seeds from it before any network call and coalesces to it when a
// response omits a field, so a session where load() never resolves (signed out, latched 'failed'
// auth, flags fetch leaving state 'unavailable') renders what the server would have said.
// presentationMode defaults ON deliberately — an unresolved session redacts rather than leaks.
export const DEFAULT_USER_SETTINGS: UserSettings = { theme: 'light', presentationMode: true };

export function isTheme(value: unknown): value is Theme {
	return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}
